export const VIEW_EARINIGCOMPLETE_PAGE = "VIEW_EARINIGCOMPLETE_PAGE";
export const VIEW_EARINIGCOMPLETE_PAGE_Hide = "VIEW_EARINIGCOMPLETE_PAGE_Hide";
export const VIEW_ChooseMounting_PAGE_Hide = "VIEW_ChooseMounting_PAGE_Hide";
export const VIEW_ChooseMounting_PAGE_View = "VIEW_ChooseMounting_PAGE_View";
export const VIEW_HideEditChooseThisMounting = "VIEW_HideEditChooseThisMounting";
export const VIEW_ViewEditChooseThisMounting = "VIEW_ViewEditChooseThisMounting";
